import GuestCheckoutSuccess from './guest-checkout-success';

export default GuestCheckoutSuccess;
